module.exports = __webpack_public_path__ + "static/media/point_icon.42871eb0.png";